import React, { useState, useContext, useCallback, useEffect } from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import Mark from 'mark.js';

import { Context } from '@store/store';

const PageFrame = ({ pageFrameTags, bookId }) => {
  const [state] = useContext(Context);
  const [pageFrameDimensions, setPageFrameDimensions] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const markInstance = new Mark(document.querySelectorAll('.t'));
    markInstance.unmark({
      done: () => {
        markInstance.mark(state.searchQuery, {
          accuracy: 'exactly',
          debug: true,
          ignorePunctuation: ':;.,-–—‒_(){}[]!\'"+='.split(''),
          acrossElements: true,
        });
      },
    });
    return () => {
      markInstance.unmark();
    };
  }, [state.searchQuery]);

  const inlineWidthAndHeightToPfOptions = {
    replace: node => {
      if (
        node.attribs &&
        node.name === 'div' &&
        node.attribs.id?.startsWith('pf')
      ) {
        const props = attributesToProps(node.attribs);
        return (
          <div
            {...props}
            style={{
              width: `${pageFrameDimensions.width}px`,
              height: `${pageFrameDimensions.height}px`,
              border: '1px solid rgba(0,0,0,0.05)',
            }}
          >
            {domToReact(node.children, inlineScaleToPcOptions)}
          </div>
        );
      }
    },
  };

  const inlineScaleToPcOptions = {
    replace: node => {
      if (
        node.attribs &&
        node.name === 'div' &&
        node.attribs.class.startsWith('pc')
      ) {
        const props = attributesToProps(node.attribs);
        return (
          <div
            {...props}
            ref={measuredRef}
            style={{ transform: `scale(${state.zoomScale})` }}
          >
            {domToReact(node.children, replaceImageSrcOptions)}
          </div>
        );
      }
    },
  };

  const replaceImageSrcOptions = {
    replace: node => {
      if (node.attribs && node.name === 'img') {
        const src = node.attribs.src;
        let modifiedSrc =
          process.env.REACT_APP_ONLINE2_VIEW_URL + `${bookId}/` + src;
        if (state.efedNoAuth ?? null) {
          modifiedSrc = modifiedSrc.replace("/online2/", "/efed/");
        }
        const props = attributesToProps(node.attribs);
        const modProps = { ...props, src: modifiedSrc };
        return <img {...modProps} alt="" />;
      }
    },
  };

  const measuredRef = useCallback(
    node => {
      if (node !== null) {
        setPageFrameDimensions({
          width: state.rotatePage === 90 || state.rotatePage === 270 ? node.getBoundingClientRect().height : node.getBoundingClientRect().width,
          height: state.rotatePage === 90 || state.rotatePage === 270 ? node.getBoundingClientRect().width : node.getBoundingClientRect().height,
        });
      }
    },
    [state.zoomScale],
    [state.rotatePage],
  );

  return (
    <React.Fragment>
      {parse(pageFrameTags, inlineWidthAndHeightToPfOptions)}
    </React.Fragment>
  );
};

export default PageFrame;
